export const defaultFormData = {
	weekdays: [],
	name: '',
	price: null,
	start_time: '',
	end_time: '',
	teachers: null,
	students: [],
}
